export function transformScannerInputToDeviceSerial(newValue: string): string {
  // ")01=05745000379040)10=00)21=0234"
  const m = newValue.match(/\)01=\d+\)10=(\d{2})\)21=(\d{4})/);
  return m ? `C3w${m[1]}${m[2]}` : newValue;
}
